import { IconFont, Image, Text } from '@byecode/ui'
import { timeDistance, useAtomData } from '@lighthouse/shared'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { appAtom } from '@/atoms/application/state'

const SCxContainer = styled.div`
    width: 100%;
`

const SCxContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: var(--font-size-normal);
`

const SCxTips = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    background-color: var(--color-theme-2);
    color: var(--color-theme-7);
    border-radius: 4px;
    gap: 4px;
    font-size: var(--font-size-sm);
`
const SCxQrCode = styled.div`
    position: relative;
    width: 144px;
    height: 144px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 2px solid var(--color-gray-200);
    background: var(--color-white);
    overflow: hidden;
`

const SCxQrCodeContainer = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 4px;
`

const SCxImgThumbnail = styled.div`
    position: absolute;
    left: 4px;
    top: 4px;
    width: 132px;
    height: 132px;
    border-radius: 7px;
    background: var(--color-gray-100);
    overflow: hidden;
`

interface TestQrcodeProps {
    qrcode: string
}

export const TestQrcode: React.FC<TestQrcodeProps> = ({ qrcode }) => {
    const publishCreatedTime = useAtomData(
        appAtom,
        useCallback(s => s.updatedTime ?? Date.now(), [])
    )
    const [loading, setLoading] = useState(true)

    return (
        <SCxContent>
            <SCxTips>
                <IconFont type="WarningCircle" color="var(--color-theme-7)" size={16} />
                ios设备需将试用小程序删除再扫码
            </SCxTips>
            <SCxQrCodeContainer>
                <SCxQrCode>
                    <Image
                        src={qrcode}
                        onLoad={() => {
                            setLoading(false)
                        }}
                    />
                    {loading && <SCxImgThumbnail />}

                    {/* <QRCode size={133} value={qrcode ?? ''} renderAs="canvas" /> */}
                </SCxQrCode>
                <Text size={16} weight={500} lineHeight="24px" style={{ marginTop: 8 }}>
                    扫码预览小程序
                </Text>
                <Text lineHeight="20px" size={12} color="var(--color-gray-400)">
                    当更新发布应用，会同步更新体验版小程序
                </Text>
                <Text lineHeight="20px" size={12} color="var(--color-gray-400)">
                    {timeDistance(publishCreatedTime)} 更新
                </Text>
            </SCxQrCodeContainer>
        </SCxContent>
    )
}
